module.exports = __webpack_public_path__ + "static/media/step-ladders-large.bd54fcce.png";